export const getSellerContactsAvgPeriodStart = (
  transactions: { signature_date?: string | null }[],
  now: Date = new Date(),
) => {
  const oneYearAgo = new Date(now);
  oneYearAgo.setDate(oneYearAgo.getDate() - 365);

  const signaturesInYear = transactions
    .map(tx => tx.signature_date)
    .filter((date): date is string => date != null)
    .map(date => new Date(date))
    .filter(date => date >= oneYearAgo && date <= now);

  if (signaturesInYear.length === 0) {
    return oneYearAgo;
  }

  const firstTx = signaturesInYear.reduce((earliest, date) =>
    date < earliest ? date : earliest,
  );

  return firstTx;
};

export const getMonthsElapsed = (periodStart: Date, now: Date = new Date()) => {
  // Calendar-month difference is already the number of months elapsed; no `+ 1`
  // (that inflated the divisor by a month and understated the per-month average).
  // `Math.max(1, …)` still guards the same-month / divide-by-zero case.
  const months =
    (now.getFullYear() - periodStart.getFullYear()) * 12 +
    (now.getMonth() - periodStart.getMonth());
  return Math.max(1, months);
};
